import { helpZhHant } from "./help.zh-Hant";
export const languageChineseTraditional = {
    modelPresetToolUse: "工具使用",
    modelPresetToolUseHelp: "允許此預設呼叫已設定的工具（MCP）。預設關閉。工具執行時不使用串流。",
    "formating": {
        "main": "主要提示詞",
        "jailbreak": "越獄提示詞",
        "chats": "過往對話",
        "lorebook": "Lorebook",
        "globalNote": "全域備註",
        "authorNote": "作者備註",
        "lastChat": "最近一次對話",
        "description": "角色描述",
        "personaPrompt": "使用者人設",
        "plain": "基礎提示詞",
        "memory": "Supa/HypaMemory",
        "postEverything": "系統提示詞結束",
    },
    "errors": {
        "toomuchtoken": "錯誤：所需的 Token 超過了最大可用上下文上限",
        "unknownModel": "錯誤：無法識別所選的模型",
        "httpError": "錯誤：請求發生錯誤：",
        "noData": "檔案格式錯誤或資料已損毀。",
        "onlyOneChat": "至少需要一個對話",
        "noUserIcon": "請先設定您的個人頭像。",
        "emptyText": "文字內容為空。",
        "wrongPassword": "密碼錯誤",
        "networkFetch": "這通常是由於網路連線不穩定或伺服器故障引起的。",
        "networkFetchWeb": "這可能是由 CORS 錯誤引起的。這種情況只會在使用網頁版時發生，因為瀏覽器存在一些限制。請嘗試使用桌面版或其他版本的 RisuBard。",
        "networkFetchPlain": "這可能是一次資料抓取（Fetch）錯誤。請嘗試在設定中關閉強制抓取。",
        "requestLogRemoved": "該請求記錄已被刪除。",
        "requestLogRemovedDesc": "當用戶端重新整理或重新載入時，該請求記錄會被刪除。",
        "vertexAuthError": "缺少 Vertex AI 驗證詳細資料。",
        "coldStorageWriteFailed": "冷儲存寫入失敗。您的對話資料已被保留。",
        "coldStorageVerifyFailed": "冷儲存驗證失敗。您的對話資料已被保留。",
        "persistFailureAttemptedSize": "嘗試儲存大小",
        "persistFailureTitle": "伺服器儲存失敗 — 變更未寫入磁碟",
    },
    "showHelp": "顯示幫助",
    help: helpZhHant,
    "setup": {
        "chooseProvider": "選擇 AI 供應商",
        "openaikey": "使用 OpenAI API 金鑰（推薦）",
        "openaiProxy": "OpenAI 反向代理",
        "setupmodelself": "其他／自行設定",
        "inputApiKey": "請在此輸入 API 金鑰",
        "apiKeyhelp": "可在以下取得 API 金鑰：",
        "setupSelfHelp": "歡迎畫面結束後，可前往設定中自行設定。",
        "theme": "選擇介面主題",
        "themeDescWifulike": "不適合在行動裝置上使用",
        "themeDescWifuCut": "適合在行動裝置上使用",
        "themeDescClassic": "適用於所有裝置",
        "texttheme": "設定文字顏色",
        "inputName": "最後，請輸入您的暱稱。",
        "welcome": "歡迎使用 RisuBard！我將引導您進行設定。請問我該如何稱呼您？",
        "welcome2": "您好，{username}！在開始之前，我會問您一些問題，稍後可在設定中進行修改。\n\n首先，請選擇 AI 供應商。",
        "openRouterProvider": "OpenRouter 提供許多模型，部分免費且未經內容過濾。",
        "hordeProvider": "Horde 提供免費服務，但回應時間較長且品質較低。",
        "setProviderLater": "還有其他供應商，您可以稍後在設定中設定。如想稍後設定，請選擇此選項。",
        "setupOpenAI": "使用 OpenAI，需要取得 API 金鑰。\n1. 前往 https://beta.openai.com/ \n2. 使用帳號登入 \n3. 前往 https://beta.openai.com/account/api-keys \n4. 點擊「Create New API Key」，並命名金鑰。 \n5. 複製該金鑰。 \n6. 回到 RisuBard\n7. 貼上金鑰並點擊「發送」。",
        "setupClaude": "使用 Claude 需要取得 API 金鑰。",
        "setupClaudeSteps": [
            "請前往此連結並使用 Google 帳號登入",
            "輸入您的資訊並點擊「繼續」（Continue）",
            "在第一個方框輸入任意名稱，然後點擊「建立帳號」（Create Account）",
            "按下「購買點數」（Buy Credits）按鈕",
            "按下「完成設定」（Complete Setup）按鈕",
            "如上圖所示輸入，除了國家部分請選擇您所在的國家，然後點擊「繼續」（Continue）",
            "新增您的付款方式並點擊「繼續」（Continue）",
            "註冊付款方式後，點擊「Add Funds」並儲值。最少可儲值 5 美元，也可以設定自動續約儲值。",
            "儲值後，前往 Dashboard 頁面並點擊「Get API Keys」按鈕",
            "按下「建立 API 金鑰」（Create API Key）按鈕",
            "如上圖所示輸入後點擊「Add」",
            "複製金鑰並貼上，然後點擊「發送」。",
        ],
        "setupOpenRouter": "使用 OpenRouter 需要取得 API 金鑰。\n1. 前往 https://openrouter.ai/keys\n2. 點擊「Create Key」\n3. 任意命名金鑰名稱。\n4. 複製該金鑰。\n5. 回到 RisuBard\n6. 貼上金鑰並點擊「發送」。",
        "allDone": "完成所有設定！請稍待片刻。",
        "setupLaterMessage": "歡迎，{username}！您希望我引導您完成設定還是自行設定？",
        "setupMessageOption1": "引導我完成設定",
        "setupMessageOption1Desc": "推薦新手使用者選用。",
        "setupMessageOption2": "由我自己完成設定",
        "claudeDesc": "Claude 是由 Anthropic 開發的 AI 模型，是 OpenAI 的強大競爭對手。若您希望使用非英語語言，它在各方面的表現往往優於 GPT。",
        "openAIDesc": "OpenAI GPT 是高品質的 AI 模型，但它付費且存在內容審核，在非英語環境下表現較弱。",
        "chooseChatType": "很好！現在請選擇聊天語言。",
        "chooseChatTypeOption1": "全英語",
        "chooseChatTypeOption1Desc": "推薦英語使用者。AI 將使用英語進行輸入和輸出。",
        "chooseChatTypeOption2": "英語處理",
        "chooseChatTypeOption2Desc": "推薦非英語使用者。AI 內部以英語處理，但以您的語言進行輸入與輸出。",
        "chooseChatTypeOption3": "無語言側重",
        "chooseChatTypeOption3Desc": "AI 將完全以您的語言進行處理，但可能會降低回應品質。",
        "chooseCheapOrMemory": "除此之外，您更傾向於記憶功能還是節省成本？",
        "chooseCheapOrMemoryOption1": "記憶功能",
        "chooseCheapOrMemoryOption1Desc": "AI 會記住更多內容，但費用較高。",
        "chooseCheapOrMemoryOption2": "省錢模式",
        "chooseCheapOrMemoryOption2Desc": "AI 會記住較少內容，但費用更低。",
        "chooseCheapOrMemoryOption3": "平衡",
        "chooseCheapOrMemoryOption3Desc": "AI 記住的內容多於省錢模式，但不及使用記憶功能。",
        "chooseCheapOrMemoryOption4": "無限制",
        "chooseCheapOrMemoryOption4Desc": "AI 會記住幾乎所有內容，但費用極高。",
        "finally": "最後，您是否希望使用進階工具？",
        "finallyOption1": "是",
        "finallyOption1Desc": "使用進階工具會使介面變得更複雜。推薦進階使用者使用。",
        "finallyOption2": "否",
        "finallyOption2Desc": "不使用進階工具，保持介面簡潔。推薦新手使用者選用。",
        "igpPrompt": "若 IGP 提示詞不為空，將在主要模型請求完成後作為情緒模型執行，並將結果附加至主要模型的回應後。",
    },
    "triggerCategories": {
        "Special": "特殊",
        "Control": "控制",
        "Chat": "對話",
        "Low Level": "低層級存取",
        "Alert": "警示",
        "Lorebook V2": "Lorebook V2",
        "String": "字串",
        "Data": "資料",
        "Array": "陣列",
        "Others": "其他",
        "Deprecated": "已棄用",
    },
    "triggerDesc": {
        "v2Header": "標頭",
        "v2HeaderDesc": "區塊標頭定義",
        "v2If": "如果",
        "v2IfDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2Else": "否則",
        "v2ElseDesc": "否則",
        "v2EndIndent": "結束縮排",
        "v2EndIndentDesc": "結束縮排",
        "v2SetVar": "設定變數",
        "v2SetVarDesc": "設定變數 {{var}} {{operator}} {{value}}",
        "v2Loop": "無限循環",
        "v2LoopDesc": "無限循環",
        "v2BreakLoop": "中斷循環",
        "v2BreakLoopDesc": "中斷循環",
        "v2RunTrigger": "執行觸發式",
        "v2RunTriggerDesc": "執行觸發式 {{target}}",
        "v2ConsoleLog": "控制台記錄",
        "v2ConsoleLogDesc": "控制台記錄 {{source}}",
        "v2StopTrigger": "停止觸發式",
        "v2StopTriggerDesc": "停止觸發式",
        "v2CutChat": "剪下對話",
        "v2CutChatDesc": "剪下對話從 {{start}} 到 {{end}}",
        "v2ModifyChat": "修改對話",
        "v2ModifyChatDesc": "修改對話索引 {{index}} 為 {{value}}",
        "v2SystemPrompt": "新增系統提示詞",
        "v2SystemPromptDesc": "在 {{location}} 新增系統提示詞，內容為 {{value}}",
        "v2Impersonate": "發送對話",
        "v2ImpersonateDesc": "作為 {{role}} 發送對話，內容為 {{value}}",
        "v2Command": "執行指令",
        "v2CommandDesc": "執行指令 {{value}}",
        "v2SendAIprompt": "發送 AI 提示詞",
        "v2SendAIpromptDesc": "發送 AI 提示詞",
        "v2ImgGen": "圖片生成",
        "v2ImgGenDesc": "從 {{value}} 生成圖片，負面提示詞為 {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "檢查相似度",
        "v2CheckSimilarityDesc": "檢查 {{source}} 與 {{value}} 之間的相似度 => {{outputVar}}",
        "v2RunLLM": "執行模型",
        "v2RunLLMDesc": "從 {{value}} 發送請求到模型 => {{outputVar}}",
        "v2ShowAlert": "顯示警示",
        "v2ShowAlertDesc": "顯示警示 {{value}}",
        "v2ExtractRegex": "提取正規表達式",
        "v2ExtractRegexDesc": "從 {{value}} 中使用正規表達式 {{regexType}} {{regex}} 和旗標 {{flagsType}} {{flags}} 提取文字，並將結果儲存為 {{resultType}} {{result}} => {{outputVar}}",
        "v2RegexTest": "正規表達式測試",
        "v2RegexTestDesc": "使用正規表達式 {{regex}} 和旗標 {{flags}} 測試 {{value}} => {{outputVar}}",
        "v2GetLastMessage": "取得最後一條訊息",
        "v2GetLastMessageDesc": "取得最後一條訊息 => {{outputVar}}",
        "v2GetMessageAtIndex": "取得指定索引的訊息",
        "v2GetMessageAtIndexDesc": "取得索引為 {{index}} 的訊息 => {{outputVar}}",
        "v2GetMessageCount": "取得訊息數量",
        "v2GetMessageCountDesc": "取得訊息數量 => {{outputVar}}",
        "v2GetLorebook": "取得 Lorebook",
        "v2GetLorebookDesc": "取得名稱為 {{target}} 的 Lorebook => {{outputVar}}",
        "v2GetLorebookCount": "取得 Lorebook 數量",
        "v2GetLorebookCountDesc": "取得 Lorebook 數量 => {{outputVar}}",
        "v2GetLorebookEntry": "透過索引取得 Lorebook",
        "v2GetLorebookEntryDesc": "透過索引 {{index}} 取得 Lorebook => {{outputVar}}",
        "v2SetLorebookActivation": "設定 Lorebook 啟用狀態",
        "v2SetLorebookActivationDesc": "設定索引為 {{index}} 的 Lorebook 啟用狀態為 {{value}}",
        "v2GetLorebookIndexViaName": "透過名稱取得 Lorebook 索引",
        "v2GetLorebookIndexViaNameDesc": "透過名稱 {{name}} 取得 Lorebook 索引 => {{outputVar}}",
        "v2ModifyLorebook": "修改 Lorebook",
        "v2ModifyLorebookDesc": "修改名稱為 {{target}} 的 Lorebook 內容為 {{value}}",
        "v2LoopNTimes": "循環 N 次",
        "v2LoopNTimesDesc": "循環 {{value}} 次",
        "v2Random": "隨機數",
        "v2RandomDesc": "產生 {{min}} 到 {{max}} 之間的隨機數 => {{outputVar}}",
        "v2GetCharAt": "取得指定位置的字元",
        "v2GetCharAtDesc": "從 {{source}} 取得索引 {{index}} 的字元 => {{outputVar}}",
        "v2GetCharCount": "取得字元數量",
        "v2GetCharCountDesc": "取得 {{source}} 的字元數量 => {{outputVar}}",
        "v2ToLowerCase": "轉換為小寫",
        "v2ToLowerCaseDesc": "將 {{source}} 轉換為小寫 => {{outputVar}}",
        "v2ToUpperCase": "轉換為大寫",
        "v2ToUpperCaseDesc": "將 {{source}} 轉換為大寫 => {{outputVar}}",
        "v2SetCharAt": "設定指定位置的字元",
        "v2SetCharAtDesc": "將 {{source}} 中索引 {{index}} 的字元設定為 {{value}} => {{outputVar}}",
        "v2SplitString": "分割字串",
        "v2SplitStringDesc": "使用 {{delimiter}} 分割 {{source}} => {{outputVar}}",
        "v2GetCharacterDesc": "取得角色描述",
        "v2GetCharacterDescDesc": "取得角色描述 => {{outputVar}}",
        "v2SetCharacterDesc": "設定角色描述",
        "v2SetCharacterDescDesc": "設定角色描述為 {{value}}",
        "v2GetPersonaDesc": "取得人設描述",
        "v2GetPersonaDescDesc": "取得人設描述 => {{outputVar}}",
        "v2SetPersonaDesc": "設定人設描述",
        "v2SetPersonaDescDesc": "設定人設描述為 {{value}}",
        "v2GetReplaceGlobalNote": "取得替換全域備註",
        "v2GetReplaceGlobalNoteDesc": "取得替換全域備註 => {{outputVar}}",
        "v2SetReplaceGlobalNote": "設定替換全域備註",
        "v2SetReplaceGlobalNoteDesc": "設定替換全域備註為 {{value}}",
        "v2GetAuthorNote": "取得作者備註",
        "v2GetAuthorNoteDesc": "取得作者備註 => {{outputVar}}",
        "v2SetAuthorNote": "設定作者備註",
        "v2SetAuthorNoteDesc": "設定作者備註為 {{value}}",
        "v2Comment": "加入註釋",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "宣告區域變數",
        "v2DeclareLocalVarDesc": "宣告區域變數 {{var}} 初始值為 {{value}}",
        "v2MakeArrayVar": "建立陣列變數",
        "v2MakeArrayVarDesc": "建立陣列變數 {{var}}",
        "v2GetArrayVarLength": "取得陣列變數長度",
        "v2GetArrayVarLengthDesc": "取得陣列變數 {{var}} 的長度 => {{outputVar}}",
        "v2GetArrayVar": "取得陣列變數",
        "v2GetArrayVarDesc": "取得陣列變數 {{var}} 索引 {{index}} 的值 => {{outputVar}}",
        "v2SetArrayVar": "設定陣列變數",
        "v2SetArrayVarDesc": "設定陣列變數 {{var}} 索引 {{index}} 的值為 {{value}}",
        "v2PushArrayVar": "加入至陣列變數",
        "v2PushArrayVarDesc": "將 {{value}} 加入至陣列變數 {{var}}",
        "v2PopArrayVar": "從陣列變數移除並取得最後一個值",
        "v2PopArrayVarDesc": "從陣列變數 {{var}} 移除最後一個值 => {{outputVar}}",
        "v2ShiftArrayVar": "從陣列變數移除並取得第一個值",
        "v2ShiftArrayVarDesc": "從陣列變數 {{var}} 移除第一個值 => {{outputVar}}",
        "v2UnshiftArrayVar": "新增至陣列變數開頭",
        "v2UnshiftArrayVarDesc": "將 {{value}} 新增至陣列變數 {{var}} 的開頭",
        "v2SpliceArrayVar": "插入至陣列變數指定位置",
        "v2SpliceArrayVarDesc": "將 {{value}} 插入至陣列變數 {{var}} 的 {{start}} 位置",
        "v2SliceArrayVar": "擷取陣列片段",
        "v2SliceArrayVarDesc": "擷取陣列變數 {{var}} 從 {{start}} 到 {{end}} 的片段 => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "取得值在陣列變數中的索引",
        "v2GetIndexOfValueInArrayVarDesc": "取得 {{value}} 在陣列變數 {{var}} 中的索引 => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "從陣列變數移除指定索引",
        "v2RemoveIndexFromArrayVarDesc": "從陣列變數 {{var}} 移除索引為 {{index}} 的值",
        "v2JoinArrayVar": "合併陣列為字串",
        "v2JoinArrayVarDesc": "使用 {{delimiter}} 合併陣列 {{var}} 為字串 => {{outputVar}}",
        "v2MakeDictVar": "建立字典變數",
        "v2MakeDictVarDesc": "建立字典變數 {{var}}",
        "v2GetDictVar": "取得字典值",
        "v2GetDictVarDesc": "從字典 {{var}} 取得鍵 {{key}} 的值 => {{outputVar}}",
        "v2SetDictVar": "設定字典值",
        "v2SetDictVarDesc": "設定字典 {{var}} 中鍵 {{key}} 的值為 {{value}}",
        "v2DeleteDictKey": "刪除字典鍵",
        "v2DeleteDictKeyDesc": "從字典 {{var}} 刪除鍵 {{key}}",
        "v2HasDictKey": "檢查字典鍵是否存在",
        "v2HasDictKeyDesc": "檢查字典 {{var}} 是否包含鍵 {{key}} => {{outputVar}}",
        "v2ClearDict": "清空字典",
        "v2ClearDictDesc": "清空字典 {{var}}",
        "v2GetDictSize": "取得字典大小",
        "v2GetDictSizeDesc": "取得字典 {{var}} 的大小 => {{outputVar}}",
        "v2GetDictKeys": "取得字典鍵列表",
        "v2GetDictKeysDesc": "取得字典 {{var}} 的所有鍵 => {{outputVar}}",
        "v2GetDictValues": "取得字典值列表",
        "v2GetDictValuesDesc": "取得字典 {{var}} 的所有值 => {{outputVar}}",
        "v2ConcatString": "串接字串",
        "v2ConcatStringDesc": "串接 {{source1}} 和 {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "取得最後一條使用者訊息",
        "v2GetLastUserMessageDesc": "取得最後一條使用者訊息 => {{outputVar}}",
        "v2GetLastCharMessage": "取得最後一條角色訊息",
        "v2GetLastCharMessageDesc": "取得最後一條角色訊息 => {{outputVar}}",
        "v2GetFirstMessage": "取得第一條訊息",
        "v2GetFirstMessageDesc": "取得第一條訊息 => {{outputVar}}",
        "v2GetAlertInput": "取得警示輸入",
        "v2GetAlertInputDesc": "取得警示輸入 => {{outputVar}}",
        "v2GetAlertSelect": "取得警示選擇",
        "v2GetAlertSelectDesc": "取得警示選擇，顯示 {{display}} 選項 {{value}} => {{outputVar}}",
        "v2UnsupportedTrigger": "不支援的觸發式",
        "v2UnsupportedTriggerDesc": "不支援的觸發式",
        "v2GetDisplayState": "取得顯示狀態",
        "v2GetDisplayStateDesc": "取得顯示狀態 => {{outputVar}}",
        "v2SetDisplayState": "設定顯示狀態",
        "v2SetDisplayStateDesc": "設定顯示狀態為 {{value}}",
        "v2UpdateGUI": "更新介面",
        "v2UpdateGUIDesc": "更新介面",
        "v2UpdateChatAt": "更新指定索引的對話",
        "v2UpdateChatAtDesc": "重繪索引為 {{index}} 的對話",
        "v2Wait": "等待",
        "v2WaitDesc": "等待 {{value}} 秒",
        "v2GetRequestState": "取得請求內容",
        "v2GetRequestStateDesc": "取得索引為 {{index}} 的請求內容 => {{outputVar}}",
        "v2SetRequestState": "設定請求內容",
        "v2SetRequestStateDesc": "將索引為 {{index}} 的請求內容設定為 {{value}}",
        "v2GetRequestStateRole": "取得請求角色",
        "v2GetRequestStateRoleDesc": "取得索引為 {{index}} 的請求角色 => {{outputVar}}",
        "v2SetRequestStateRole": "設定請求角色",
        "v2SetRequestStateRoleDesc": "將索引為 {{index}} 的請求角色設定為 {{value}}",
        "v2GetRequestStateLength": "取得請求長度",
        "v2GetRequestStateLengthDesc": "取得請求長度 => {{outputVar}}",
        "v2IfAdvanced": "如果（進階）",
        "v2IfAdvancedDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "快速搜尋對話",
        "v2QuickSearchChatDesc": "在深度 {{depth}} 內的對話中以條件 {{condition}} 快速搜尋 {{value}} => {{outputVar}}",
        "v2StopPromptSending": "停止發送提示詞",
        "v2StopPromptSendingDesc": "停止發送提示詞",
        "v2Tokenize": "計算 Token 數",
        "v2TokenizeDesc": "計算 {{value}} 的 Token 數 => {{outputVar}}",
        "v2GetAllLorebooks": "取得所有 Lorebook",
        "v2GetAllLorebooksDesc": "取得所有 Lorebook 提示詞並以陣列傳回 => {{outputVar}}",
        "v2GetLorebookByName": "透過名稱取得 Lorebook 索引",
        "v2GetLorebookByNameDesc": "透過名稱 {{name}} 取得 Lorebook 索引陣列 => {{outputVar}}",
        "v2GetLorebookByIndex": "透過索引取得 Lorebook",
        "v2GetLorebookByIndexDesc": "取得索引為 {{index}} 的 Lorebook 提示詞 => {{outputVar}}",
        "v2CreateLorebook": "建立 Lorebook",
        "v2CreateLorebookDesc": "建立名稱為 {{name}}，關鍵字為 {{key}}，內容為 {{content}} 的 Lorebook",
        "v2ModifyLorebookByIndex": "修改 Lorebook",
        "v2ModifyLorebookByIndexDesc": "修改索引為 {{index}} 的 Lorebook，名稱為 {{name}}，關鍵字為 {{key}}，內容為 {{content}}",
        "v2DeleteLorebookByIndex": "刪除 Lorebook",
        "v2DeleteLorebookByIndexDesc": "刪除索引為 {{index}} 的 Lorebook",
        "v2GetLorebookCountNew": "取得 Lorebook 數量",
        "v2GetLorebookCountNewDesc": "取得 Lorebook 總數 => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "設定 Lorebook 常駐",
        "v2SetLorebookAlwaysActiveDesc": "將索引為 {{index}} 的 Lorebook 設定為常駐 {{value}}",
        "v2Calculate": "計算",
        "v2CalculateDesc": "計算 {{expression}} => {{outputVar}}",
        "v2ReplaceString": "替換字串",
        "v2ReplaceStringDesc": "使用正規表達式 {{regex}} 將 {{source}} 替換為 {{replacement}} => {{outputVar}}",
    },
    "triggerInputLabels": {
        "value": "值",
        "var": "變數",
        "varName": "變數名稱",
        "outputVar": "輸出變數",
        "name": "名稱",
        "index": "索引",
        "source": "來源",
        "target": "目標",
        "condition": "條件",
        "operator": "運算子",
        "role": "身分",
        "location": "位置",
        "prompt": "提示詞",
        "model": "模型",
        "start": "開始",
        "end": "結束",
        "min": "最小",
        "max": "最大",
        "delimiter": "分隔符號",
        "depth": "深度",
        "key": "鍵",
        "alertContent": "提示內容",
        "options": "選項",
        "cmd": "指令",
        "regex": "正規表達式",
        "replacement": "替換內容",
        "flags": "旗標",
        "negPrompt": "負面提示詞",
        "resultFormat": "結果格式",
        "activationKeys": "啟用關鍵字",
        "insertOrder": "插入順序",
        "sysStart": "系統開始",
        "sysHistoryEnd": "系統歷史結束",
        "sysPromptEnd": "系統提示詞結束",
        "addElse": "新增否則（Else）",
        "alwaysActive": "總是啟用",
        "trigger": "觸發式",
        "triggerOn": "觸發於",
        "valueTypeDesc": "直接使用輸入值",
        "varTypeDesc": "使用儲存在變數中的值",
        "conditionEqual": "等於 (=)",
        "conditionNotEqual": "不等於 (≠)",
        "conditionGreater": "大於 (>)",
        "conditionLess": "小於 (<)",
        "conditionGreaterEqual": "大於或等於 (≥)",
        "conditionLessEqual": "小於或等於 (≤)",
        "conditionSimilar": "相似 (≒)",
        "conditionContains": "包含 (∋)",
        "conditionIn": "在其中 (∈)",
        "conditionNotContains": "不包含 (∌)",
        "conditionNotIn": "不在其中 (∉)",
        "conditionTruthy": "為真 (≡)",
        "operatorSet": "設定 (=)",
        "operatorAdd": "加 (+=)",
        "operatorSubtract": "減 (-=)",
        "operatorMultiply": "乘 (*=)",
        "operatorDivide": "除 (/=)",
        "operatorModulo": "取餘 (%=)",
        "searchLoose": "寬鬆搜尋",
        "searchStrict": "嚴格搜尋",
        "searchRegex": "正規表達式搜尋",
        "modelMain": "主要模型",
        "modelSub": "輔助模型",
        "roleUser": "使用者",
        "roleChar": "角色",
        "roleSystem": "系統",
        "roleAssistant": "助理",
        "boolTrue": "True",
        "boolFalse": "False",
        "boolNull": "Null",
        "helpVarName": "輸入變數名稱",
        "helpOutputVar": "輸入用於儲存結果的變數名稱",
        "helpIndex": "陣列或訊息索引編號",
        "helpRegex": "輸入正規表達式樣式",
        "helpFlags": "正規表達式旗標",
        "helpDelimiter": "用於分割字串的分隔符號",
        "helpActivationKeys": "以逗號分隔的啟用關鍵字",
        "helpInsertOrder": "插入順序",
        "helpDepth": "搜尋訊息的深度",
        "helpMinMax": "最小值和最大值範圍",
        "helpSlot": "使用 {{slot}} 保持不變",
        "expression": "表達式",
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteConfirm": "確定要刪除「{name}」嗎？",
        "inlayDeleteMultipleConfirm": "確定要刪除選取的 {count} 個資源嗎？",
        "inlayDeleteSelected": "刪除選取項目",
        "inlayDeselectAll": "取消全選",
        "inlayEmpty": "沒有儲存的嵌入資源",
        "inlayEmptyDesc": "在對話中附加或生成的圖片、音訊和影片將顯示在這裡",
        "inlayExplorer": "嵌入資源瀏覽器",
        "inlayImageGallery": "嵌入內容圖庫",
        "inlayImageGalleryEmptyDesc": "在對話中附加或生成的圖片將顯示在這裡",
        "inlaySelectAll": "全選",
        "inlayTotalAssets": "共{count}個資源",
        "inlayDelete": "刪除",
        "inlayLoadingMore": "載入中...",
        "inlayCreatedAt": "建立：",
        "inlayUpdatedAt": "更新：",
        "inlaySort": "排序",
        "inlaySortUpdatedDesc": "更新時間 ↓",
        "inlaySortUpdatedAsc": "更新時間 ↑",
        "inlaySortCreatedDesc": "建立時間 ↓",
        "inlaySortCreatedAsc": "建立時間 ↑",
        "inlayFilter": "篩選",
        "inlayFilterAll": "全部",
        "inlayFilterMetaMissing": "缺少中繼資料",
        "inlayFilterOrphanCharacter": "孤立角色",
        "inlayFilterOrphanChat": "孤立對話",
        "inlayOriginalLoadNeeded": "需要載入原始檔案",
        "inlayAudioAsset": "音訊資源",
        "inlayVideoAsset": "影片資源",
        "inlaySignatureAsset": "簽名資源",
        "inlayInfo": "資訊",
        "inlayManualMapping": "手動對應",
        "inlayActions": "操作",
        "inlayLoadingOriginal": "正在載入原始圖片...",
        "inlaySave": "儲存",
        "inlaySaved": "已儲存！",
        "inlayFilterOrphanMessage": "不在訊息中",
        "inlayScanMessages": "掃描訊息",
        "inlayScanning": "掃描中...",
        "inlayScanDone": "已掃描 {count} 條訊息",
        "inlayImageList": "圖片清單",
    },
    "confirm": "確定",
    "yes": "是",
    "no": "否",
    "goback": "返回",
    "botSettings": "機器人設定",
    "model": "模型",
    "apiKey": "API 金鑰",
    "providerURL": "請求地址（URL）",
    "providerJSON": "請求主體（JSON）",
    "mainPrompt": "主要提示詞",
    "jailbreakPrompt": "越獄提示詞",
    "globalNote": "全域備註",
    "autoSuggest": "自動建議",
    "tokens": "Token",
    "maxContextSize": "最大上下文（Max Context Size）",
    "maxResponseSize": "最大回應（Max Response Size）",
    "temperature": "溫度（Temperature）",
    "frequencyPenalty": "頻率懲罰（Frequency Penalty）",
    "presensePenalty": "存在懲罰（Presence Penalty）",
    "advancedSettings": "進階設定",
    "advancedSettingsWarn": "警告：若不確定選項的作用，請勿修改！",
    "formatingOrder": "格式順序",
    "authorNote": "作者備註",
    "firstMessage": "初始訊息",
    "description": "描述",
    "note": "說明",
    "jailbreakToggle": "使用越獄提示詞",
    "charIcon": "角色頭像",
    "characterDisplay": "角色顯示",
    "viewScreen": "額外角色畫面",
    "none": "無",
    "emotionImage": "情緒立繪",
    "noImages": "沒有圖片",
    "noBias": "無 Bias",
    "image": "圖片",
    "name": "名稱",
    "folderName": "資料夾名稱",
    "folderRemoveConfirm": "此資料夾包含 Lorebook。確定要刪除該資料夾及所有內容嗎？",
    "emotion": "情緒名稱",
    "value": "值",
    "reroll": "重新生成",
    "hideMessagePageCount": "隱藏訊息頁數計數器",
    "deleteRerollMessage": "刪除重新生成的訊息",
    "deleteRerollMessageConfirm": "刪除目前選取的重新生成訊息？",
    "rerollConfirm": "生成新訊息並加入列表嗎？",
    "noSwipesRerollConfirm": "沒有其他重新生成的訊息。生成新訊息並加入列表嗎？",
    "chatList": "對話列表",
    "removeChat": "確定要移除此對話嗎？",
    "loreBook": "Lorebook",
    "character": "角色",
    "Chat": "對話",
    "globalLoreInfo": "角色 Lorebook 適用於該角色的所有對話。",
    "group": "群組",
    "localLoreInfo": "對話 Lorebook 僅適用於目前對話。",
    "removeConfirm": "您確定要刪除：",
    "removeConfirm2": "您**真的**確定要刪除：",
    "exportConfirm": "確定要匯出這些資料嗎？",
    "insertOrder": "插入順序",
    "activationKeys": "關鍵字",
    "activationKeysInfo": "使用逗號分隔",
    "prompt": "提示詞",
    "loreBookDepth": "Lorebook 搜尋深度",
    "loreBookToken": "Lorebook 最大 Token",
    "removeCharacter": "移除角色",
    "exportCharacter": "匯出角色",
    "characterPackage": "角色包",
    "characterPackageExport": "匯出角色包",
    "characterPackageImport": "匯入角色包（zip）",
    "characterPackageCharacter": "角色",
    "characterPackageChats": "對話記錄",
    "characterPackagePersona": "人設",
    "characterPackageInlays": "嵌入內容",
    "characterPackageNone": "無",
    "characterPackageChatCount": "",
    "characterPackageInlayCount": "",
    "characterPackageExportSuccess": "角色包匯出成功。",
    "characterPackageImportSuccess": "角色包匯入成功。",
    "characterPackageImportSummary": "角色包內容",
    "characterPackageInvalidZip": "無效的角色包檔案。",
    "characterPackageProgressCharacter": "正在建立角色...",
    "characterPackageProgressChats": "正在寫入對話記錄...",
    "characterPackageProgressPersona": "正在寫入人設...",
    "characterPackageProgressInlays": "正在寫入嵌入內容",
    "characterPackageProgressFinalizing": "正在完成...",
    "characterPackageProgressReading": "正在讀取角色包...",
    "characterPackageProgressImportChar": "正在匯入角色...",
    "characterPackageProgressImportPersona": "正在匯入人設...",
    "characterPackageProgressImportChats": "正在匯入對話記錄...",
    "characterPackageProgressImportInlays": "正在匯入嵌入內容",
    "characterPackageEmpty": "空殼",
    "characterPackageEmptyWarning": "角色資料為空，仍要匯入嗎？",
    "characterPackageNameMismatch": "角色名稱不符，仍要匯入嗎？",
    "characterPackageImportToChar": "將角色包匯入至角色",
    "characterPackageLicenseWarning": "角色匯出受授權政策限制",
    "characterPackageCheckCount": "檢查",
    "userSetting": "使用者設定",
    "username": "您的名稱",
    "userIcon": "您的頭像",
    "successExport": "已成功匯出並儲存至您的下載資料夾",
    "successImport": "成功匯入",
    "moduleCreated": "模組已建立",
    "moduleUpdated": "模組已更新",
    "moduleDeleted": "模組已刪除",
    "importedCharacter": "匯入角色",
    "alwaysActive": "始終啟用",
    "additionalPrompt": "額外提示詞",
    "descriptionPrefix": "描述前綴",
    "forceReplaceUrl": "反向代理",
    "emotionWarn": "正在使用輔助模型。",
    "plugin": "外掛",
    "language": "語言",
    "UiLanguage": "介面語言",
    "createfromScratch": "從頭建立",
    "importCharacter": "匯入角色",
    "translator": "翻譯器",
    "disabled": "關閉",
    "noPluginSelected": "已選擇將模型交由外掛處理，但未指定外掛。",
    "text": "文字",
    "UISize": "對話文字大小",
    "newVersion": "發現更新，是否進行安裝？",
    "updateAvailable": "v{{version}} 更新可用",
    "updateRequired": "v{{version}} 必要更新可用",
    "updateOutdated": "v{{version}} — 您的版本過舊",
    "updatePopupTitle": "有可用更新",
    "updatePopupTitleRequired": "必要更新",
    "updatePopupTitleOutdated": "版本過舊",
    "updatePopupDesc": "新版本 <b>v{{latest}}</b> 已可用。（目前版本：v{{current}}）",
    "updatePopupViewRelease": "查看版本說明",
    "updatePopupLater": "稍後再說",
    "selfUpdateNow": "立即更新",
    "selfUpdateInProgress": "更新中...",
    "selfUpdateDone": "更新完成",
    "selfUpdateFailed": "更新失敗",
    "selfUpdateReloadHint": "請重新整理頁面以使用新版本。",
    "selfUpdateReload": "重新整理",
    "close": "關閉",
    "remindLaterQuestion": "什麼時候再提醒您？",
    "remindIgnore": "忽略",
    "remindLater1Day": "1天後提醒",
    "remindLater3Days": "3天後提醒",
    "remindLater5Days": "5天後提醒",
    "remindLater1Week": "1週後提醒",
    "display": "顯示 & 音訊",
    "useCustomBackground": "自訂背景",
    "translateInput": "翻譯輸入",
    "autoTranslation": "自動翻譯",
    "fullscreen": "全螢幕",
    "playMessage": "收到訊息時播放音效",
    "iconSize": "頭像大小",
    "single": "單個",
    "multiple": "多個",
    "useCharLorebook": "使用角色 Lorebook",
    "selectChar": "選擇角色",
    "askLoadFirstMsg": "是否載入初始訊息？",
    "theme": "介面主題",
    "editOrder": "編輯順序",
    "submodel": "輔助模型",
    "timeOutinSec": "超時時間（秒）",
    "emotionPrompt": "情緒提示詞",
    "singleView": "單角色模式",
    "SpacedView": "多角色模式",
    "emphasizedView": "雙角色模式",
    "pluginWarn": "警告：安裝不明來源的外掛可能產生安全風險。",
    "pluginConfirm": "確定要匯入此外掛嗎？請確保來源可信。",
    "pluginContainsExternalMedia": "此外掛包含外部媒體。",
    "pluginContainsExternalJS": "此外掛包含外部 JavaScript。",
    "waifuWidth": "角色對話框寬度",
    "files": "檔案",
    "backupConfirm": "您確定要儲存備份嗎？",
    "backupLoadConfirm": "確定要載入備份嗎？目前的資料將會被覆蓋！",
    "backupLoadConfirm2": "**最後警告**：確定要載入備份嗎？這將會清除目前所有的資料！",
    "others": "其他",
    "presets": "預設",
    "themePresets": "介面主題預設",
    "imageGeneration": "圖片生成",
    "provider": "供應商",
    "key": "金鑰",
    "noData": "沒有資料",
    "currentImageGeneration": "目前圖片生成資料",
    "promptPreprocess": "使用提示詞預處理",
    "SwipeRegenerate": "點擊箭頭以重新生成訊息",
    "removeMessageOnly": "只刪除這則訊息",
    "removeMessageAndAfter": "刪除這則及之後的訊息 ({} 則)",
    "messageRemoved": "訊息已刪除",
    "messagesRemoved": "已刪除 {} 則訊息",
    "confirmReroll": "重新生成訊息時確認",
    "textColor": "文字顏色",
    "classicRisu": "經典 Risu",
    "highcontrast": "高對比度",
    "requestretrys": "請求失敗時重試",
    "utilityBot": "工具機器人",
    "waifuWidth2": "角色顯示寬度",
    "sayNothing": "無輸入內容時自動填入 'say nothing'",
    "regexScript": "正規表達式",
    "type": "類型",
    "editInput": "修改輸入",
    "editOutput": "修改輸出",
    "editProcess": "修改發送資料",
    "loadLatest": "讀取最新的備份",
    "loadOthers": "讀取其他備份",
    "exampleMessage": "示範訊息",
    "creatorNotes": "創作者備註",
    "systemPrompt": "系統提示詞",
    "characterNotes": "角色備註",
    "personality": "性格",
    "scenario": "情境",
    "alternateGreetings": "備選初始訊息",
    "unrecommended": "不建議",
    "chatNotes": "對話備註",
    "showUnrecommended": "顯示不建議的設定",
    "allowV2Plugin": "允許已棄用的 V2.0 外掛",
    "altGreet": "備選問候語",
    "scripts": "指令碼",
    "settings": "設定",
    "selective": "選擇性",
    "SecondaryKeys": "次要關鍵字",
    "useGlobalSettings": "使用全域設定",
    "recursiveScanning": "遞迴掃描",
    "creator": "創作者",
    "CharVersion": "角色版本",
    "Speech": "語音",
    "useExperimental": "啟用實驗性功能",
    "showMemoryLimit": "顯示記憶上限",
    "showFirstMessagePages": "顯示初始訊息分頁",
    "roundIcons": "圓形頭像",
    "streaming": "串流回應",
    "chatBot": "對話角色",
    "otherBots": "其他機器人",
    "user": "使用者",
    "additionalAssets": "額外資源",
    "editDisplay": "修改顯示",
    "textBackgrounds": "自訂文字視窗顏色",
    "textBorder": "文字邊框",
    "textScreenRound": "圓角化文字視窗",
    "textScreenBorder": "文字視窗邊框",
    "ttsReadOnlyQuoted": "僅朗讀引號內容",
    "ttsStop": "停止語音合成",
    "replaceGlobalNote": "替換全域備註",
    "charLoreBook": "角色 Lorebook",
    "globalLoreBook": "全域 Lorebook",
    "globalRegexScript": "全域正規表達式",
    "accessibility": "輔助功能",
    "sendWithEnter": "使用 Enter 鍵發送（未勾選時，發送方式將改為 Shift + Enter。）",
    "fixedChatTextarea": "固定對話視窗底部",
    "clickToEdit": "點擊文字進行編輯",
    "enableBlockPartialEdit": "啟用區塊局部編輯（懸停以編輯特定區塊）",
    "enableDragPartialEdit": "啟用拖曳局部編輯（選取文字以編輯）",
    "setNodePassword": "設定密碼以提升安全性",
    "inputNodePassword": "輸入密碼。如果忘記密碼，請刪除伺服器檔案中的 save/__password.txt 並重新啟動伺服器。",
    "simple": "基本",
    "advanced": "進階",
    "askReRollAutoSuggestions": "重新生成自動建議",
    "creatingSuggestions": "正在生成建議⋯",
    "active": "活躍",
    "loreRandomActivation": "啟用 Lorebook 隨機觸發機制",
    "activationProbability": "機率",
    "hub": "RisuRealm",
    "tags": "標籤",
    "backgroundHTML": "背景嵌入",
    "copied": "已複製",
    "useChatCopy": "啟用對話訊息複製",
    "useChatSticker": "啟用對話貼圖",
    "useAdditionalAssetsPreview": "使用額外資源預覽",
    "autoTranslateInput": "自動輸入翻譯",
    "enterMessageForTranslateToEnglish": "輸入訊息以翻譯成英文",
    "recent": "最新",
    "downloads": "下載",
    "trending": "熱門",
    "imageCompression": "圖片壓縮",
    "inlayImageLossless": "以無損格式儲存嵌入內容",
    "inlayImagePriority": "優先以圖片形式渲染嵌入內容",
    "inlayCompressAll": "壓縮所有嵌入內容",
    "inlayCompressing": "壓縮中...",
    "inlayCompressConfirm": "所有嵌入內容將被壓縮為 WebP 格式，此操作無法撤銷。是否繼續？",
    "inlayCompressDone": "壓縮完成",
    "inlayCompressCount": " 張圖片已壓縮",
    "saved": "已儲存",
    "notLoggedIn": "尚未登入 Risu 帳號",
    "SaveDataInAccount": "儲存資料到帳號",
    "dataSavingInAccount": "正在將資料儲存到帳號",
    "logout": "登出",
    "loadDataFromAccount": "從帳號讀取資料",
    "saveCurrentDataToAccount": "儲存目前資料到帳號",
    "chatAssumed": "",
    "proxyAPIKey": "代理金鑰/密碼",
    "proxyRequestModel": "請求模型",
    "officialWiki": "官方 Wiki",
    "officialWikiDesc": "歡迎查看 RisuBard 官方的 Wiki。",
    "officialDiscord": "官方 Discord",
    "officialDiscordDesc": "RisuBard 官方的 Discord 伺服器",
    "persona": "人設",
    "icon": "圖示",
    "account": "帳號",
    "remove": "移除",
    "able": "啟用",
    "assetWidth": "額外資源圖片最大寬度",
    "animationSpeed": "動畫速度",
    "screenshot": "截圖",
    "screenshotSaved": "截圖已儲存",
    "createBotwithAI": "使用 AI 建立角色",
    "changeFolderName": "輸入新資料夾名稱（留空以取消）",
    "cancel": "取消",
    "renameFolder": "重新命名資料夾",
    "changeFolderColor": "變更資料夾顏色",
    "changeFolderImage": "變更資料夾圖片",
    "fullWordMatching": "完整單詞匹配",
    "botSettingAtStart": "啟動時顯示角色設定選單",
    "triggerStart": "對話發送時觸發",
    "triggerInput": "使用者送出訊息時觸發",
    "triggerOutput": "角色送出訊息後觸發",
    "triggerManual": "僅限手動觸發",
    "triggerCondVar": "如果變數為",
    "triggerCondExists": "如果對話中存在文字",
    "triggerScript": "觸發式",
    "triggerMatchRegex": "與正規表達式匹配",
    "triggerMatchLoose": "寬鬆匹配",
    "triggerMatchStrict": "嚴格匹配",
    "searchDepth": "搜尋深度",
    "equal": "等於",
    "notEqual": "不等於",
    "greater": "大於",
    "less": "小於",
    "greaterEqual": "大於或等於",
    "lessEqual": "小於或等於",
    "triggerEffSysPrompt": "加入系統提示詞",
    "triggerEffSetVar": "修改變數",
    "triggerEffImperson": "發送對話訊息",
    "triggerEffCommand": "執行指令",
    "triggerEffRunTrigger": "執行觸發式",
    "triggerEffStop": "停止發送提示詞",
    "triggerEffCall": "呼叫觸發式",
    "varableName": "變數名稱",
    "role": "身分",
    "location": "位置",
    "promptstart": "提示詞開始",
    "promptend": "提示詞結束",
    "historyend": "對話歷史結束",
    "always": "始終",
    "noEffect": "無效果",
    "invaildTriggerEffect": "此效果不適用於該觸發類型。",
    "operator": "運算子",
    "TriggerSetToVar": "設定為變數",
    "TriggerAddToVar": "加到變數",
    "TriggerSubToVar": "從變數減去",
    "TriggerMulToVar": "將變數乘以值",
    "TriggerDivToVar": "將變數除以值",
    "isNull": "尚未設定",
    "ifChatIndex": "如果對話索引",
    "ifRandom": "如果隨機",
    "ifValue": "如果值",
    "hideRealm": "RisuRealm 預設折疊",
    "hideAllImages": "隱藏所有圖片",
    "popularityLevel": "人氣 {}",
    "colorScheme": "配色方案",
    "rangeStart": "範圍開始",
    "rangeEnd": "範圍結束",
    "untilChatEnd": "直到對話結束",
    "usePromptTemplate": "使用提示詞模板",
    "specialType": "特殊類型",
    "noSpecialType": "無特殊類型",
    "forceProxyAsOpenAI": "強制代理格式為 OpenAI",
    "promptTemplate": "提示詞模板",
    "customInnerFormat": "自訂內部格式",
    "innerFormat": "內部格式",
    "HypaMemory": "HypaMemory",
    "ToggleHypaMemory": "啟動 HypaMemory",
    "resetPromptTemplateConfirm": "您真的確定要重置提示詞模板嗎？",
    "emotionMethod": "情緒檢測方式",
    "continueResponse": "接續回應內容",
    "showMenuChatList": "在選單中顯示對話列表",
    "translatorLanguage": "翻譯目標語言",
    "translatorType": "翻譯器類型",
    "htmlTranslation": "HTML 翻譯",
    "deeplKey": "DeepL API 金鑰",
    "deeplFreeKey": "DeepL 免費 API 金鑰",
    "deeplXUrl": "DeepLX URL",
    "deeplXToken": "DeepLX Token",
    "exportPersona": "匯出人設",
    "importPersona": "匯入使用者設定",
    "export": "匯出",
    "import": "匯入",
    "useNamePrefix": "使用名稱前綴",
    "textAdventureNAI": "以文字冒險形式運行",
    "appendNameNAI": "附加名稱至 NAI",
    "customStopWords": "自訂停止詞",
    "defaultPrompt": "預設提示詞",
    "additionalText": "額外描述",
    "seed": "Seed",
    "charjs": "角色 JavaScript",
    "depthPrompt": "提示詞深度",
    "largePortrait": "肖像",
    "reverseProxyOobaMode": "Ooba 模式",
    "exactTokens": "精確 Token",
    "fixedTokens": "估算 Token",
    "inlayViewScreen": "嵌入視窗",
    "imgGenPrompt": "圖片生成提示詞",
    "imgGenNegatives": "圖片生成負面提示詞",
    "imgGenInstructions": "系統提示詞",
    "usePlainFetchWarn": "使用 NovelAI 時請停用此選項，以避免 CORS 錯誤。",
    "translationPrompt": "翻譯提示詞",
    "translationResponseSize": "翻譯回應長度",
    "webdeeplwarn": "網頁版不建議使用此功能，以免發生 CORS 錯誤。",
    "saveBackupLocal": "本機儲存備份",
    "loadBackupLocal": "載入本機備份",
    "topP": "Top P",
    "genTimes": "生成次數",
    "cot": "思維鏈（CoT）",
    "forcePlainFetch": "強制原生抓取 (Plain Fetch)",
    "autoFillRequestURL": "自動填入請求 URL",
    "newOAIHandle": "新的 OpenAI 處理方式",
    "inlayImage": "嵌入圖片功能",
    "nativeAutomark": "實驗性本機自動標記",
    "assistantPrefill": "助理預填",
    "postEndInnerFormat": "結尾內部格式",
    "sendChatAsSystem": "以系統身分發送訊息",
    "sendName": "非群聊時發送名稱",
    "utilOverride": "實用程式覆寫",
    "template": "模板",
    "chatAsOriginalOnSystem": "以原始角色身分發送",
    "exportAsDataset": "將對話紀錄匯出成資料集",
    "editTranslationDisplay": "修改翻譯顯示",
    "selectModel": "選擇模型",
    "autoRemoveThoughtTag": "刪除思維標籤",
    "customChainOfThought": "自訂思維鏈",
    "maxThoughtTagDepth": "思維標籤最大深度",
    "openRouterFallback": "啟用備援模型",
    "openRouterMiddleOut": "啟用中段截斷",
    "openRouterProviderOrder": "供應商優先順序",
    "openRouterProviderOnly": "允許的供應商",
    "openRouterProviderIgnore": "忽略的供應商",
    "openRouterSearchModel": "搜尋模型...",
    "openRouterSortByName": "按名稱",
    "openRouterSortByPrice": "按價格",
    "openRouterSortByProvider": "按供應商",
    "openRouterSortAsc": "升序",
    "openRouterSortDesc": "降序",
    "geminiApiKey": "Gemini API 金鑰",
    "memoryLimitThickness": "記憶上限厚度",
    "inputCardPassword": "輸入角色卡密碼",
    "ccv2Desc": "V2 角色卡是目前廣泛使用的標準角色前端格式。",
    "ccv3Desc": "V3 角色卡是用於對話角色前端的新型格式。",
    "rccDesc": "Risu Refined 角色卡具有密碼保護、完整性驗證等附加功能。",
    "password": "密碼",
    "license": "授權",
    "licenseDesc": "您可以設定下載授權，限制角色卡對提示詞的使用。",
    "passwordDesc": "您可以為角色卡設定密碼，防止未經授權的存取。",
    "largePersonaPortrait": "人設肖像",
    "module": "模組",
    "modules": "模組",
    "noModules": "尚未安裝任何模組。",
    "createModule": "建立模組",
    "basicInfo": "基本資料",
    "moduleContent": "模組內容",
    "confirmRemoveModuleFeature": "確定要移除此功能嗎？此操作無法復原。",
    "editModule": "編輯模組",
    "importModule": "匯入模組",
    "download": "下載",
    "edit": "編輯",
    "enableGlobal": "全域啟用",
    "chatModulesInfo": "可在此選擇為目前對話啟用或停用個別模組。",
    "sideMenuRerollButton": "在側邊欄選單顯示重新生成按鈕",
    "persistentStorage": "永久儲存",
    "persistentStorageSuccess": "儲存資料已成功設定為永久保存。",
    "persistentStorageFail": "無法啟用永久儲存。請確認是否拒絕了請求，或瀏覽器不支援此功能。",
    "persistentStorageRecommended": "建議使用永久儲存",
    "persistentStorageDesc": "您的瀏覽器支援永久儲存，建議啟用以提升效能和使用者體驗。",
    "enable": "啟用",
    "postFile": "上傳檔案",
    "requestInfoInsideChat": "在對話中顯示發送資料",
    "inputTokens": "輸入 Token",
    "outputTokens": "輸出 Token",
    "tokenWarning": "Token 計算可能不精確，僅作參考。",
    "log": "記錄",
    "popularityLevelDesc": "人氣會隨著下載量等增加。3.7 人氣約等於 1 次下載。",
    "additionalParams": "額外參數",
    "heightMode": "高度模式",
    "useAdvancedEditor": "使用進階編輯器",
    "noWaitForTranslate": "不等待翻譯",
    "antiClaudeOverload": "防止 Claude 因過載而中斷請求",
    "activeTabChange": "由於其他分頁正在運行，目前分頁已暫停。點擊「確定」以切換回此分頁。",
    "addCharacter": "新增角色",
    "importFromRealm": "從 RisuRealm 選擇",
    "importFromRealmDesc": "RisuRealm 提供超過 1000 位角色",
    "random": "隨機",
    "metaData": "中繼資料",
    "autoContinueMinTokens": "目標 Token（自動繼續）",
    "autoContinueChat": "防止不完整回應（自動繼續）",
    "removeIncompleteResponse": "移除不完整句子",
    "tokenizer": "Tokenizer",
    "chatFormating": "對話格式",
    "useInstructPrompt": "啟用指令提示詞",
    "textAreaSize": "輸入欄大小",
    "textAreaTextSize": "輸入欄文字大小",
    "sideBarSize": "側邊欄大小",
    "embedding": "嵌入",
    "syntax": "語法",
    "run": "執行",
    "noMessage": "輸入內容以開始對話。",
    "combineTranslation": "合併翻譯",
    "dynamicAssets": "動態資源",
    "dynamicAssetsEditDisplay": "在介面上使用動態資源",
    "longTermMemory": "長期記憶",
    "grid": "網格",
    "list": "列表",
    "trash": "垃圾桶",
    "trashDesc": "刪除的角色將移至垃圾桶，您可選擇還原或永久刪除。垃圾桶內的資料將於 3 天後自動永久刪除。",
    "shareExport": "分享/匯出",
    "risupresetDesc": "Risupreset 是專為 RisuBard 預設設計的格式。",
    "risuMDesc": "RisuM 是專為 RisuBard 模組設計的格式。",
    "jsonDesc": "JSON 是一種易於人類與機器讀寫的純文字格式。",
    "nickname": "暱稱",
    "useRegexLorebook": "使用正規表達式",
    "customPromptTemplateToggle": "自訂開關",
    "defaultVariables": "預設變數",
    "lowLevelAccess": "低層級存取",
    "resultStoredVar": "儲存結果的變數",
    "triggerEffRunLLM": "執行主要模型",
    "triggerEffectSendAI": "重新發送至 AI",
    "triggerEffCheckSim": "檢查相似度",
    "triggerEffShowAlert": "顯示警示",
    "normal": "正常",
    "error": "錯誤",
    "input": "輸入",
    "select": "選擇",
    "options": "選項",
    "alertContent": "提示內容",
    "lowLevelAccessConfirm": "此內容包含低層級存取設定，可直接存取 AI 模型與您的本機資料。確定要匯入嗎？",
    "triggerLowLevelOnly": "此觸發式需要低層級存取權限。請先至角色或模組的進階設定中啟用「低層級存取」。",
    "truthy": "真值",
    "extractRegex": "使用正規表達式提取文字",
    "runImgGen": "執行圖片生成",
    "cutChat": "分割對話",
    "modifyChat": "修改對話",
    "regex": "正規表達式",
    "flags": "旗標",
    "resultFormat": "結果格式",
    "negPrompt": "負面提示詞",
    "start": "開始",
    "end": "結束",
    "index": "索引",
    "search": "搜尋",
    "goCharacterOnImport": "匯入後跳轉至角色頁面",
    "format": "格式",
    "v2Warning": "警告：已停止支援舊版 V2 角色卡，匯入時可能會遺失部分資料。",
    "applyModule": "套用模組",
    "successApplyModule": "已成功套用模組",
    "font": "字型",
    "lineHeight": "行距",
    "loadAutoServerBackup": "讀取伺服器自動備份",
    "notCharxWarn": "此角色包含多項資源，建議匯出為 CharX 格式以確保最佳相容性。",
    "noPlugins": "未安裝外掛",
    "legacyTranslation": "舊版翻譯",
    "clipboardSuccess": "已複製到剪貼簿",
    "translateContent": "翻譯內容",
    "doNotTranslate": "不進行翻譯",
    "includePersonaName": "包含人設名稱",
    "hidePersonaName": "隱藏人設名稱",
    "triggerSwitchWarn": "更改觸發類型將會清除現有的觸發式。確定要繼續嗎？",
    "codeMode": "程式碼",
    "blockMode": "區塊",
    "helpBlock": "幫助",
    "hideChatIcon": "隱藏頭像",
    "loadInternalBackup": "讀取內部備份",
    "createCopy": "新建副本",
    "bindPersona": "綁定人設",
    "chatOptions": "對話選項",
    "doYouWantToBindCurrentPersona": "要將目前人設綁定至此對話嗎？",
    "doYouWantToUnbindCurrentPersona": "要解除此對話的人設綁定嗎？",
    "personaBindingLabel": "人設綁定",
    "pinPersonaOnNewChat": "建立新聊天時固定人設",
    "personaBindedSuccess": "人設綁定已完成",
    "personaUnbindedSuccess": "人設綁定已解除",
    "personaBindChange": "更換人設",
    "personaBindUnbind": "解除綁定",
    "personaBindCurrent": "綁定目前人設",
    "personaSelectOther": "選擇其他人設",
    "parameters": "參數",
    "sizeAndSpeed": "大小與速度",
    "useLegacyGUI": "切換至舊版介面",
    "claudeCachingExperimental": "Claude 快取功能 (實驗性)",
    "openClose": "開啟／關閉",
    "hideApiKeys": "隱藏 API 金鑰",
    "unformatQuotes": "停用引號格式",
    "enableDevTools": "啟用開發者工具",
    "selectFile": "選擇檔案",
    "namespace": "命名空間",
    "moduleIntergration": "模組整合",
    "previewInfo": "此預覽顯示模型處理前的提示詞。",
    "miscTools": "其他工具",
    "promptConvertion": "提示詞轉換",
    "convertionStep1": "請選擇與提示詞相關的檔案（支援 Context、Instruct 及 Sampler JSON）",
    "customCSS": "自訂 CSS",
    "betaMobileGUI": "測試版行動介面",
    "enableScrollToActiveChar": "啟用捲動至目前角色",
    "menu": "選單",
    "jsonSchema": "JSON Schema",
    "enableJsonSchema": "啟用 JSON Schema",
    "strictJsonSchema": "嚴格 JSON Schema",
    "extractJson": "提取 JSON",
    "reloadSession": "發現更新版本的儲存資料，正在重新載入對話⋯",
    "fixMarkdownNewline": "修正 Markdown 換行",
    "customQuotes": "自訂引號",
    "leadingSingleQuote": "上單引號",
    "leadingDoubleQuote": "上雙引號",
    "trailingSingleQuote": "下單引號",
    "trailingDoubleQuote": "下雙引號",
    "translatorNote": "翻譯備註 (TL Note)",
    "formatGroupInSingle": "單一群組格式",
    "groupInnerFormat": "非發言者內部格式",
    "chatHTML": "對話介面 HTML",
    "logShare": "顯示分享記錄按鈕",
    "preview": "預覽",
    "recommended": "推薦",
    "newChat": "新對話",
    "predictedOutput": "預測輸出",
    "systemContentReplacement": "替換系統內容",
    "systemRoleReplacement": "替換系統角色",
    "seperateParameters": "分離參數",
    "seperateParametersEnabled": "啟用分離參數",
    "summarizationPrompt": "總結提示詞",
    "reSummarizationPrompt": "重新總結提示詞",
    "translatorPrompt": "翻譯提示詞",
    "translateBeforeHTMLFormatting": "於 HTML 格式化前翻譯",
    "retranslate": "重新翻譯",
    "editTranslation": "編輯翻譯",
    "editTranslationSave": "儲存翻譯",
    "exportTranslationCache": "匯出翻譯快取",
    "importTranslationCache": "匯入翻譯快取",
    "importTranslationCacheConfirm": "這將把快取條目合併到目前翻譯快取中，且現有的相同鍵值將被覆蓋。是否繼續？",
    "importTranslationCacheSuccess": "已匯入 {0} 筆翻譯快取。",
    "exportTranslationCacheEmpty": "翻譯快取為空。",
    "clearTranslationCache": "清除翻譯快取",
    "clearTranslationCacheConfirm": "這將刪除所有翻譯快取條目，此操作不可撤銷。是否繼續？",
    "loading": "載入中",
    "autoTranslateCachedOnly": "僅自動翻譯已快取的訊息",
    "notification": "使用系統通知",
    "permissionDenied": "權限被您的瀏覽器或操作系統拒絕",
    "customFlags": "自訂旗標（Flags）",
    "enableCustomFlags": "啟用自訂旗標（Flags）",
    "googleCloudTokenization": "Google Cloud Tokenization",
    "presetChain": "預設鏈結 (Preset Chain)",
    "legacyMediaFindings": "舊版媒體發現",
    "staticsDisclaimer": "統計資料建基於 2024 年 7 月之後的資料，可能存在部分誤差。",
    "subtitles": "字幕",
    "subtitlesWarning1": "您必須使用具有音訊／影片輸入的模型才能使用此功能。",
    "subtitlesWarning2": "您必須使用具有串流回應功能的模型才能使用此功能。",
    "reset": "重置",
    "assetMaxDifference": "資源最大差異",
    "sourceLanguage": "原文語言",
    "destinationLanguage": "目標語言",
    "noWebGPU": "由於目前的瀏覽器或作業系統不支援 WebGPU，效能將大幅下降。",
    "menuSideBar": "選單側邊欄",
    "home": "首頁",
    "showSavingIcon": "顯示儲存圖示",
    "pluginVersionWarn": "這是 {{plugin_version}} 版本的外掛，與目前 RisuBard 版本不相容。請更新外掛至 {{required_version}} 版本。",
    "imageTranslation": "圖像翻譯",
    "banCharacterset": "自動重新生成字元集",
    "realmDirectOpen": "在 RisuRealm 中直接開啟角色",
    "showPromptComparison": "顯示提示詞比較",
    "inlayErrorResponse": "嵌入錯誤回應",
    "triggerOn": "觸發於",
    "noConfig": "無設定",
    "varName": "變數名稱",
    "var": "變數",
    "condition": "條件",
    "trigger": "觸發式",
    "outputVar": "輸出變數",
    "source": "來源",
    "cmd": "指令",
    "sysStart": "系統開始",
    "sysHistoryEnd": "系統歷史結束",
    "sysPromptEnd": "系統提示詞結束",
    "target": "目標",
    "addElse": "新增否則（Else）",
    "min": "最小",
    "max": "最大",
    "delimiter": "分隔符號",
    "deleteCount": "刪除數量",
    "triggerEffRunAxLLM": "執行輔助模型",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 是一個使用總結和向量搜尋的長期記憶系統。",
        "supaMemoryPromptPlaceHolder": "留空以使用預設值",
        "maxMemoryTokensRatioLabel": "最大記憶 Token 比例（估算值）",
        "maxMemoryTokensRatioError": "無法計算最大記憶 Token 比例",
        "memoryTokensRatioLabel": "記憶 Token 比例",
        "extraSummarizationRatioLabel": "額外總結比例",
        "maxChatsPerSummaryLabel": "每個總結的最大訊息數",
        "queryChatCountLabel": "查詢對話訊息數量",
        "recentMemoryRatioLabel": "最近記憶比例",
        "similarMemoryRatioLabel": "相似記憶比例",
        "randomMemoryRatioLabel": "隨機記憶比例",
        "enableSimilarityCorrectionLabel": "啟用相似度校正",
        "preserveOrphanedMemoryLabel": "保留孤立記憶",
        "applyRegexScriptWhenRerollingLabel": "重新生成時套用正規表達式腳本",
        "doNotSummarizeUserMessageLabel": "不對使用者訊息進行總結",
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3 資料",
        "resetConfirmMessage": "此操作無法復原。確定要重置 HypaV3 資料嗎？",
        "resetConfirmSecondMessage": "**警告**：此操作不可逆。您確定要重置 HypaV3 資料嗎？",
        "convertLabel": "尚無總結，但您可以將 HypaV2 資料轉換為 V3。",
        "convertButton": "轉換為 V3",
        "convertSuccessMessage": "成功將 HypaV2 資料轉換為 V3",
        "convertErrorMessage": "無法將 HypaV2 資料轉換為 V3：{0}",
        "noSummariesLabel": "尚無總結",
        "searchPlaceholder": "輸入 #N、ID 或搜尋關鍵字",
        "summaryNumberLabel": "總結 #{0}",
        "deleteThisConfirmMessage": "確定刪除此總結？",
        "deleteAfterConfirmMessage": "確定刪除此總結及之後的所有總結？",
        "deleteAfterConfirmSecondMessage": "此操作無法復原。確定要繼續嗎？",
        "translationLabel": "翻譯",
        "rerolledSummaryLabel": "重新生成的總結",
        "rerolledTranslationLabel": "重新生成的總結翻譯",
        "connectedMessageCountLabel": "關聯訊息（{0}）",
        "connectedFirstMessageLabel": "初始訊息",
        "connectedMessageRoleLabel": "{0} 的訊息",
        "connectedMessageNotFoundLabel": "找不到訊息",
        "connectedMessageLoadingError": "載入關聯訊息時出錯：{0}",
        "connectedMessageTranslationLabel": "翻譯",
        "nextSummarizationFirstMessageLabel": "初始訊息",
        "nextSummarizationNoMessageIdLabel": "無訊息 ID",
        "nextSummarizationLabel": "HypaV3 將總結 [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "警告：找不到訊息",
        "nextSummarizationLoadingError": "載入下一個總結目標時出錯：{0}",
        "summarizationConditionLabel": "提示：當輸入 Token 超過最大上下文時，HypaV3 將開始進行總結處理。",
        "emptySelectedFirstMessageLabel": "警告：選定的初始訊息為空",
        "unclassified": "未分類",
        "reSummarize": "重新總結",
        "reSummarizing": "重新總結中...",
        "reSummarizeResult": "重新總結結果",
        "retry": "重試",
        "translate": "翻譯",
        "tag": "標籤",
        "tagManager": "標籤管理",
        "tagManagerTitle": "標籤管理 - 總結 #{0}",
        "newTagName": "新標籤名稱",
        "noTagsYet": "尚無標籤。",
        "addNewTagHint": "在上方新增標籤。",
        "categoryManager": "分類",
        "allCategories": "全部",
        "categoryName": "分類名稱",
        "noCategoriesYet": "尚無分類。",
        "addNewCategoryHint": "點擊上方的 + 按鈕新增。",
    },
    "bulkEnabling": "Lorebook 批次啟用",
    "showTranslationLoading": "顯示翻譯載入中",
    "showDeprecatedTriggerV1": "顯示已棄用的 Trigger V1",
    "showDeprecatedTriggerV2": "顯示已棄用的 Trigger V2",
    "triggerV1Warning": "Trigger V1 已棄用，未來可能會被移除。",
    "copy": "複製",
    "paste": "貼上",
    "depth": "深度",
    "returnCSSError": "回傳 CSS 錯誤",
    "alwaysActiveInChat": "始終啟用（目前對話）",
    "childLoreDesc": "這是角色 Lorebook 的副本，將保持「始終啟用」狀態，直到將其移除或於原始設定中手動停用。",
    "thinkingTokens": "思考 Token",
    "thinkingType": "思考模式",
    "adaptiveThinkingEffort": "適應性思考強度",
    "antiServerOverload": "防止伺服器過載",
    "localActivationInGlobalLorebook": "對全域 Lorebook 進行個別設定",
    "cachePoint": "快取點",
    "all": "全部",
    "showFolderNameInIcon": "在圖示中顯示資料夾名稱",
    "claudeCachingRetrival": "Claude 快取檢索",
    "claudeCachingRetrivalDesc": "透過每 4 分鐘請求一次來延長 Claude 快取的保留時間。這可以降低快取未命中率，但如果不當使用可能會增加成本。",
    "automaticCachePoint": "自動快取點",
    "experimentalChatCompression": "對話資料壓縮（實驗性功能）",
    "loadingChatData": "正在載入對話資料",
    "selectChatToView": "選擇對話以查看",
    "outputImageModal": "輸出圖片彈出視窗",
    "playMessageOnTranslateEnd": "翻譯完成後播放音訊",
    "auxModelUnderModelSettings": "在模型設定中顯示輔助模型個別設定",
    "showModelInSidebar": "在側邊欄顯示模型選擇",
    "showPresetInSidebar": "在側邊欄顯示預設選擇",
    "showPersonaInSidebar": "在側邊欄顯示人設綁定",
    "disableMobileDragDrop": "停用行動裝置角色拖曳",
    "disableToggleBinding": "停用對話切換綁定",
    "seperateModelsForAxModels": "為輔助模型設定獨立模型",
    "axModelsDef": "輔助模型定義",
    "doNotChangeSeperateModels": "套用預設時不更改獨立模型設定",
    "tools": "工具",
    "action": "動作",
    "hotkey": "快捷鍵",
    "hotkeyDesc": {
        "reroll": "重新生成",
        "unreroll": "撤銷重新生成",
        "translate": "翻譯",
        "remove": "移除",
        "edit": "編輯",
        "copy": "複製",
        "send": "發送",
        "settings": "設定",
        "home": "首頁",
        "presets": "快速切換預設",
        "persona": "快速切換人設",
        "modelSelect": "快速切換模型",
        "toggleCSS": "切換 CSS",
        "prevChar": "上一個角色",
        "nextChar": "下一個角色",
        "quickMenu": "快速選單",
        "quickSettings": "快速設定",
        "toggleVoice": "切換語音",
        "toggleLog": "切換記錄",
        "previewRequest": "預覽請求",
        "import": "匯入",
        "export": "匯出",
        "webcam": "切換網路攝影機",
        "focusInput": "聚焦輸入框",
        "scrollToActiveChar": "捲動至目前角色",
        "popupEditor": "彈出編輯器",
    },
    "screenTooSmall": "螢幕太小，無法顯示介面。",
    "advancedModelSettings": "進階模型設定",
    "fallbackModel": "備援模型",
    "fallbackWhenBlankResponse": "當回應空白時自動啟動備援模型",
    "doNotChangeFallbackModels": "套用預設時不更改備援模型設定",
    "customModels": "自訂模型",
    "igpPrompt": "IGP 提示詞",
    "useTokenizerCaching": "使用 Tokenizer 快取",
    "hypaMemoryV3Modal": "Hypa V3 視窗",
    "showMenuHypaMemoryModal": "顯示 Hypa 視窗選單",
    "promptInfoInsideChat": "將提示詞資訊加入對話",
    "promptTextInfoInsideChat": "將提示詞文字加入對話",
    "promptInfoEmptyMessage": "此訊息沒有可用的提示詞資訊。",
    "promptInfoEmptyToggle": "目前沒有啟用的自訂開關。",
    "promptInfoEmptyText": "尚未儲存提示詞文字。",
    "escapeOutput": "轉義輸出",
    "claudeBatching": "Claude 批次處理",
    "claude1HourCaching": "Claude 1 小時快取",
    "folderNameInput": "請輸入新資料夾名稱",
    "folderRemoveLengthError": "若要移除資料夾，其內容必須為空。",
    "personaNote": "使用者備註",
    "mcpAccessPrompt": "{{tool}} 正在嘗試 \"{{action}}\"。您要允許此操作嗎？",
    "rememberToolUsage": "記住工具使用選擇",
    "simplifiedToolUse": "簡化工具使用",
    "toolCalled": "工具 '{{tool}}' 已被呼叫",
    "static": "靜態",
    "dynamic": "動態",
    "assetStyle": "資源樣式",
    "insertAssetPrompt": "插入資源提示詞",
    "requestLocation": "請求位置",
    "newImageHandlingBeta": "新版圖片處理 (Beta)",
    "settingsExported": "用於錯誤回報的設定檔已匯出並複製到剪貼簿。",
    "bookmarks": "書籤",
    "noBookmarks": "無書籤",
    "bookmarkAskNameOrDefault": "輸入書籤名稱。若未輸入，將自動分配名稱。",
    "bookmarkAskNameOrCancel": "輸入書籤名稱。若未輸入，將取消重新命名。",
    "collapseAll": "全部摺疊",
    "expandAll": "全部展開",
    "hideErrorDetails": "隱藏錯誤詳情",
    "showErrorDetails": "顯示錯誤詳情",
    "dynamicOutput": "動態輸出",
    "autoAdjustSchema": "自動調整 JSON Schema",
    "dynamicMessages": "動態訊息",
    "dynamicMemory": "動態記憶",
    "dynamicResponseTiming": "動態回應時機",
    "showTypingEffect": "顯示打字效果",
    "dynamicRequest": "動態請求",
    "dynamicOutputPrompt": "動態輸出提示詞",
    "settingsCloseButtonSize": "設定關閉按鈕大小",
    "translating": "翻譯中...",
    "stackTraceTranslationFailed": "堆疊追蹤翻譯失敗。以下顯示原始混淆後的堆疊追蹤。",
    "apply": "套用",
    "add": "新增",
    "nightlyWarning": "## Nightly Builds\n\n您正在連接至軟體的 Nightly 測試版本。此版本僅供測試，且極有可能包含錯誤。**請注意，我們不直接提供此版本的任何問題排解或技術支援。**",
    "loginSionyw": "使用 Sionyw 帳號登入",
    "pluginRiskDetectedAlert": "RisuBard 偵測到可能有害的程式碼，該外掛可能**竊取您的 API 金鑰或個人資料**。強烈建議**不要安裝此外掛**。",
    "doNotInstall": "不要安裝",
    "continueAnyway": "無論如何都要繼續",
    "pluginNoRiskButAlert": "RisuBard 未偵測到有害的程式碼，但請注意，從不受信任的來源安裝外掛可能存在安全風險。",
    "pluginRisksInuserFriendly": {
        "eval": "從字串執行程式碼",
        "globalAccess": "存取全域變數",
        "thisOutsideClass": "在類別範圍外使用 'this'",
        "errorInVerification": "驗證過程中發生錯誤",
        "storageAccess": "存取儲存空間",
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "外掛試圖從字串中執行程式碼，這些字串可能經過混淆以隱藏惡意程式。",
        "globalAccess": "外掛試圖存取全域變數，這可能引發預期外的副作用或安全性漏洞。",
        "thisOutsideClass": "外掛在類別範圍外使用了 'this' 關鍵字，這可能導致意外行為或安全性問題。",
        "errorInVerification": "外掛在驗證過程中發生錯誤，代表其功能可能存在問題。",
        "storageAccess": "外掛試圖存取儲存空間，這可能導致資料外洩或遭未經授權的修改。",
    },
    "generatedByAIDisclaimer": "此內容由 AI 生成，可能包含不準確資訊或偏見。",
    "aiGenerationWarning": "內容將由 AI 生成，可能包含不準確資訊或偏見。",
    "duplicatePluginFoundUpdateIt": "偵測到已安裝相同的外掛。是否要更新現有外掛？",
    "pluginUpdateFoundInstallIt": "發現外掛更新，是否要進行安裝？",
    "goToChat": "前往對話",
    "bookmark": "書籤",
    "translate": "翻譯",
    "branch": "分支",
    "branchedText": "此對話分支自 {}。",
    "loadMore": "載入更多",
    "disableMessage": "停用訊息",
    "disableAbove": "對 AI 截斷訊息",
    "autoScrollToNewMessage": "自動捲動至新訊息",
    "alwaysScrollToNewMessage": "始終捲動至新訊息（忽略捲動位置）",
    "newMessage": "新訊息",
    "newMessageButtonStyle": "新訊息按鈕樣式",
    "newMessageButtonBottomCenter": "底部置中 (預設)",
    "newMessageButtonBottomRight": "右下角",
    "newMessageButtonBottomLeft": "左下",
    "newMessageButtonFloatingCircle": "懸浮圓形 (右下角)",
    "newMessageButtonRightCenter": "右中",
    "newMessageButtonTopBar": "頂端列",
    "trimStartNewChat": "略過「初始訊息」",
    "pluginDevelopMode": "外掛開發模式",
    "fetchLogConsent": "外掛 {} 正在請求存取記錄，此操作可能暴露敏感資訊。是否允許？",
    "getFullDatabaseConsent": "外掛 {} 正在請求存取完整資料庫，此操作可能暴露敏感資訊。是否允許？",
    "mainDomAccessConsent": "外掛 {} 正在請求存取主文件，此操作可能暴露敏感資訊。是否允許？",
    "replacerPermissionConsent": "外掛 {} 正在請求替換對話內容的權限，此操作可能被用於操縱對話。是否允許？",
    "inlayPermissionConsent": "外掛 {} 正在請求讀取附加於對話訊息的內嵌資源。是否允許？",
    "providerPermissionConsent": "外掛 {} 正在請求存取供應商的權限，此操作可能允許未授權的 API 呼叫。是否允許？",
    "sendChatConsent": "外掛 {} 正在請求以您的名義發送對話訊息的權限，這將觸發 AI 回應。是否允許？",
    "pluginV2Warning": "外掛 V2 與 V2.1 版本被視為不安全，並將於未來版本中停用。**請勿使用此版本的外掛。**若您是外掛開發者，請盡快更新至 V3。",
    "createFolderOnBranch": "在分支上建立資料夾",
    "hamburgerButtonBottom": "將選單按鈕移至側邊欄底部",
    "partialBackupFirstConfirm": "⚠️ 警告：部分本機備份 ⚠️\n\n此備份僅快速儲存必要資訊。\n\n包含：\n- 資料庫（對話記錄、角色、模組、外掛、提示詞、設定等）\n- 角色頭像（主要圖片）\n- 人設頭像及自訂背景\n- 資料夾圖片\n- 角色預設圖片\n\n⚠️ 不包含：\n- 表情圖片\n- 額外角色資源\n- VITS 語音檔案\n- 所有其他額外媒體檔案\n\n此備份不包含所有角色資源！\n如需完整備份，請使用一般本機備份。\n\n是否繼續？",
    "partialBackupSecondConfirm": "⚠️⚠️ 最終警告 ⚠️⚠️\n\n此備份僅儲存角色的頭像圖片，不儲存大多數其他資源！\n\n將儲存：\n- 資料庫（對話記錄、角色、模組、外掛、提示詞、設定等）\n- 角色頭像（主要圖片）\n- 人設頭像及自訂背景\n- 資料夾圖片\n- 角色預設圖片\n\n不會儲存：\n- 表情圖片\n- 額外角色資源\n- VITS 語音檔案\n- 所有其他媒體檔案\n\n⚠️ 僅在備份檔案不需要角色資源時才繼續執行！⚠️\n\n您確定要進行部分備份嗎？",
    "savePartialLocalBackup": "儲存部分本機備份（不含角色資源）",
    "serverBackupHeader": "RisuBard 伺服器備份",
    "serverBackupDesc": "直接在安裝 RisuBard 的裝置（伺服器）上儲存與還原備份檔案，無需下載。",
    "serverBackupSave": "儲存備份至伺服器",
    "serverBackupManage": "管理伺服器備份",
    "serverBackupSaving": "正在儲存備份至伺服器...",
    "serverBackupSaveSuccess": (filename: string, size: string) => `備份已儲存：${filename}（${size}）`,
    "serverBackupLoading": "正在載入備份列表...",
    "serverBackupEmpty": "未找到伺服器備份。",
    "serverBackupRestore": "還原",
    "serverBackupDownload": "下載",
    "serverBackupDelete": "刪除",
    "serverBackupRestoring": "正在從伺服器還原備份...",
    "serverBackupDownloading": "正在下載備份...",
    "serverBackupDeleteConfirm": (filename: string) => `刪除備份「${filename}」？此操作無法撤銷。`,
    "serverBackupDeleteSuccess": "備份已刪除。",
    "pluginProviderNotFound": "偵測到未知外掛。請更換模型或啟用對應的外掛。",
    "bootstrap": {
        "dataCorruptionDetected": (name: string, type: string) => `偵測到資料損毀\n\n模組「${name}」的 Lorebook 格式已損毀。\n\n損毀的資料類型：${type}`,
        "reportErrorQuestion": "是否要向開發者回報此錯誤？\n這有助於防止相同錯誤再次發生。\n（僅包含損毀模組的資訊，不含個人資料）",
        "diagnosticInformation": (reportData: string) => `# 診斷資訊\n\n請複製以下資訊，並透過 GitHub Issues、Discord 或社群向開發者回報。\n回報前請再次確認是否包含敏感資訊：\n\n\`\`\`json\n${reportData}\n\`\`\``,
        "resetLorebookQuestion": "是否僅重置此損毀模組的 Lorebook 資料？\n（其他模組和角色資料不受影響）\n\n選擇「否」將保留資料，但可能持續發生錯誤。",
    },
    "partialEdit": {
        "editButtonTooltip": "修改",
        "deleteButtonTooltip": "刪除",
        "deleteModalTitle": "刪除確認",
        "deleteConfirmMessage": "確定要刪除此部分嗎？",
        "deleteYes": "確定",
        "deleteNo": "取消",
        "editModalTitle": "部分編輯",
        "matchFound": (method: string) => `匹配：${method}`,
        "matchFailedTitle": "無法進行部分編輯",
        "matchFailedMessage": "無法在原始訊息中精確定位。訊息過長或含有重複內容時可能發生此問題。請改用完整訊息編輯功能。",
        "selectMatch": "選擇要修改的區塊",
        "selectDeleteMatch": "選擇要刪除的區塊",
        "matchesFound": "個匹配結果",
        "lineNumber": (line: number) => `約第 ${line} 行`,
        "saveShortcut": "儲存 (Ctrl+Enter)",
        "cancelShortcut": "取消 (Esc)",
        "save": "儲存",
        "cancel": "取消",
    },
    "enableRemoteSaving": "啟用遠端儲存",
    "blockquoteStyling": "引言樣式",
    "dynamicModelRegistry": "動態模型登錄",
    "confirmInstallPluginViaPlugin": "您正透過另一個外掛安裝新外掛。若來源外掛不可信，這將帶來安全風險。確定要繼續嗎？",
    "nodeOnlyScrollButtonType": "捲動按鈕類型",
    "scrollButtonTypeFour": "4 個按鈕",
    "scrollButtonTypeTwo": "2 個按鈕",
    "scrollButtonTypeOff": "停用",
    "seperateParametersByModel": "依模型分離參數",
    "disableSeperateParameterChangeOnPresetChange": "套用預設時不更改分離參數",
    "keepSessionAlive": "保持工作階段活躍",
    "keepSessionAlivePip": "透過子母畫面（PIP）",
    "keepSessionAliveSound": "透過音效",
    "toggleBindingLabel": "切換綁定",
    "togglePinToChat": "將目前切換值固定於此對話",
    "togglePinLabel": "固定於對話",
    "togglePinSaved": "切換值已固定於此對話。",
    "toggleSaveAsPreset": "另存為切換預設",
    "toggleLoadPreset": "載入切換預設",
    "togglePinUpdate": "儲存切換",
    "togglePinUpdateLabel": "儲存",
    "togglePinRemove": "解除對話固定並改用全域值？",
    "togglePresetNamePrompt": "輸入切換預設名稱",
    "togglePresetDelete": "── 刪除 ──",
    "togglePresetDeleteConfirm": (name: string) => `刪除切換預設「${name}」？`,
    "togglePresetSelectTitle": "切換預設",
    "togglePresetEmpty": "尚未儲存任何切換預設。",
    "togglePresetRename": "重新命名切換預設",
    "togglePresetApplied": (name: string) => `已套用「${name}」預設。`,
    "togglePresetNoPromptPreset": "無預設",
    "togglePresetEmptyFiltered": "目前提示詞預設沒有切換預設。",
    "togglePresetApplyConfirm": "目前的切換設定將被覆寫。確定要套用嗎？",
    "togglePresetMismatchConfirm": "此切換預設與目前的預設提示詞不同，套用後可能發生不相容的問題。仍要繼續嗎？",
    "togglePresetSaveNew": "儲存為新預設",
    "togglePresetOverwrite": "覆寫",
    "togglePresetOverwriteConfirm": (name: string) => `以目前切換值覆寫「${name}」？`,
    "togglePresetOverwritten": (name: string) => `預設「${name}」已覆寫。`,
    "togglePresetList": "切換預設",
    "togglePresetMenuRename": "重新命名",
    "togglePresetMenuDuplicate": "複製",
    "togglePresetMenuDelete": "刪除",
    "togglePresetMenuOverwrite": "覆寫",
    "togglePresetMenuExport": "匯出",
    "togglePresetImport": "從檔案匯入",
    "togglePresetImported": (name: string) => `已匯入預設「${name}」。`,
    "togglePresetImportError": "切換預設檔案無效。",
    "longPressToPopupEditor": "長按以開啟彈出編輯器",
    "importSaveFolderHeader": "將存檔載入至 RisuBard",
    "importSaveZip": "從存檔資料夾載入（Zip 上傳）",
    "importSaveZipDesc": "將現有 RisuBard 專案的存檔資料夾壓縮為 zip 檔案，並在此上傳以匯入資料。zip 檔案過大可能導致上傳失敗 —— 此時請將存檔資料夾直接複製到伺服器的存檔目錄中，然後重新啟動以自動完成遷移。",
    "importSaveFolderScanning": "正在掃描存檔資料夾...",
    "importSaveFolderImporting": "正在匯入存檔資料夾...",
    "importSaveFolderConfirmZip": (name: string, size: string) => `上傳「${name}」（${size}）並匯入？這將取代您目前的資料。`,
    "importSaveFolderNoDatabase": "存檔資料夾中不包含資料庫檔案（database/database.bin），無法繼續匯入。",
    "importSaveFolderSuccess": "匯入完成。",
    "cleanupMigratedFiles": "清理已遷移的存檔",
    "cleanupMigratedDesc": "若您已手動將存檔複製到伺服器的存檔資料夾，此操作將在遷移完成後刪除多餘的原始檔案以釋放磁碟空間。",
    "cleanupMigratedConfirm": (count: number, size: string) => `刪除 ${count} 個已遷移的 hex 檔案（${size}）？這些檔案已在資料庫中。`,
    "cleanupMigratedNoFiles": "沒有可清理的已遷移檔案。",
    "cleanupMigratedNotReady": "遷移尚未完成，無法清理。",
    "cleanupMigratedSuccess": (count: number, size: string) => `已移除 ${count} 個檔案，釋放 ${size}。`,
    "cleanupMigratedCleaning": "正在清理已遷移的檔案...",
    "nanoGPTLoadingAccountInfo": "正在載入帳戶資訊…",
    "nanoGPTCreditBalance": "點數餘額:",
    "nanoGPTSubscription": "訂閱",
    "nanoGPTGraceUntil": (date: string) => `至 ${date}`,
    "nanoGPTNoActiveSubscription": "無有效訂閱。",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `到期後取消 (${date})`,
    "nanoGPTWeeklyTokens": (pct: string) => `每週含輸入 Token — 已使用 ${pct}`,
    "nanoGPTDailyTokens": (pct: string) => `每日含輸入 Token — 已使用 ${pct}`,
    "nanoGPTDailyImages": (pct: string) => `每日含圖片 — 已使用 ${pct}`,
    "nanoGPTResets": (date: string) => `重置於 ${date}`,
    "nanoGPTUsed": (n: string) => `已使用 ${n}`,
    "nanoGPTRemaining": (n: string) => `剩餘 ${n}`,
    "nanoGPTRenews": (date: string) => `續訂日期: ${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "無法載入帳戶資訊。",
    "nanoGPTWeeklyTokensLabel": "每週包含輸入 Token",
    "nanoGPTDailyTokensLabel": "每日包含輸入 Token",
    "nanoGPTDailyImagesLabel": "每日包含圖片",
    "nanoGPTUsedLabel": "已使用",
    "nanoGPTRemainingLabel": "剩餘",
    "nanoGPTResetsLabel": "重置",
    "nanoGPTRenewsLabel": "續訂:",
    "nanoGPTProvider": "供應商",
    "nanoGPTProviderPayAsYouGoOnly": "(僅在按量付費模式下可用)",
    "nanoGPTProviderAuto": "自動",
    "nanoGPTProviderFree": "免費",
    "nanoGPTProviderInput": "輸入",
    "nanoGPTProviderOutput": "輸出",
    "nanoGPTProviderQuantization": "量化",
    "nanoGPTProviderUndisclosed": "未公開",
    "nanoGPTProviderCache": "快取",
    "nanoGPTProviderCacheSupported": "支援",
    "nanoGPTProviderCacheNotSupported": "不支援",
    "nanoGPTProviderCacheRead": "快取讀取",
    "nanoGPTUseSubscriptionEndpoint": "使用訂閱端點和模型",
    "modelGridCouldNotLoad": "無法載入模型清單。請檢查您的 API 金鑰。",
    "modelGridNoModelsMatch": (q: string) => `沒有匹配「${q}」的模型`,
    "modelGridContext": (n: string) => `上下文: ${n}`,
    "nanoGPTSelectFromList": "從列表中選擇",
    "nanoGPTManualInput": "手動輸入",
    "nanoGPTManualModelSelect": "手動模型選擇",
    "remoteAccess": "遠端存取",
    "remoteAccessDesc": "透過遠端存取連結，您可以從其他裝置連線至此 RisuBard 伺服器。",
    "remoteAccessOpen": "開啟遠端存取",
    "remoteAccessClose": "關閉遠端存取",
    "remoteAccessCloseConfirm": "關閉遠端存取？連結將會失效。",
    "remoteAccessDownloading": "正在下載 cloudflared...",
    "remoteAccessStarting": "正在啟動通道...",
    "remoteAccessCopyUrl": "複製 URL",
    "remoteAccessCopied": "已複製！",
    "remoteAccessDisabled": "遠端存取已被伺服器設定停用。",
    "remoteAccessError": "通道錯誤",
    "remoteAccessRetry": "重試",
    "remoteAccessQrHint": "掃描 QR 碼以連線",
    "remoteAccessWarning": "**切勿將 QR 碼或連結分享給他人。**持有連結者將能自由存取您的伺服器。若不慎外洩，請立即關閉連線並重新生成新的連結。",
    "remoteAccessInfo": "關閉遠端存取或重新啟動伺服器時，連結將立即失效並於下次生成新連結。關閉此頁面或瀏覽器不會影響目前的連線。",
    "remoteAccessTermuxWarning": "Cloudflare Quick Tunnel 在 Termux 上無法使用。請改用 Tailscale 或其他遠端存取工具。",
    "characterInfo": "角色資訊",
    "characterName": "角色名稱",
    "chatWidthFull": "無限制",
    "chatWidthStandard": "標準",
    "chatWidthWide": "寬版",
    "clearTranslationCacheSuccess": "翻譯快取已清除。",
    "copyChatConfirm": "建立副本：",
    "copyChatSuccess": "對話已複製",
    "customCSSWarning": "RisuBard 的 UI 結構（HTML/CSS）與上游 RisuAI 不同，因此既有自訂 CSS 可能破壞版面或產生非預期行為。請只在您清楚知道要覆寫哪些內容時使用。",
    "customHTMLWarning": "RisuBard 的 UI 結構（HTML/CSS）與上游 RisuAI 不同，因此既有自訂 Chat HTML 可能無法正確渲染。請只在您清楚知道要覆寫哪些內容時使用。",
    "exportTranslationCacheSuccess": "翻譯快取已成功匯出。",
    "hideLeftBarCollapseButton": "隱藏左側欄摺疊按鈕",
    "importTranslationCacheFailed": "已匯入 {0} 筆項目，但有 {1} 筆無法儲存。儲存空間可能已滿。",
    "nodeOnlyStandardChatWidth": "對話寬度",
    "resetPluginPermission": "重設權限回應",
    "resetPluginPermissionConfirm": "清除外掛「{}」所有已儲存的權限回應（允許 / 拒絕紀錄）？\n\n下次此外掛請求權限時，系統會再次詢問。",
    "resetPluginPermissionDone": "外掛「{}」的權限回應已重設",
    "saveBackupForUpstream": "匯出原版 RisuAI 相容備份",
    "saveBackupForUpstreamConfirm": "此備份用於將資料移轉到原版 RisuAI（Web/Tauri）。內嵌圖片及 BardWiki、稿件等 RisuBard 專用檔案不會包含在內。其他資料（資料庫、角色資源、冷儲存）會包含在內。\n\n若要移轉到 PocketRisu 或其他 RisuBard 安裝，請使用一般完整備份。\n\n是否繼續？",
    "system": "系統",
    "systemLogs": "系統日誌",
    "systemLogsClearAll": "全部清除",
    "systemLogsClearConfirm": "刪除所有日誌項目？此操作無法撤銷。",
    "systemLogsCopied": "已複製到剪貼簿",
    "systemLogsCopyAll": "複製可見項目",
    "systemLogsCopyEntry": "複製",
    "systemLogsDesc": "檢視此伺服器與已連線瀏覽器捕捉到的錯誤、警告與資訊事件。",
    "systemLogsEmpty": "尚無日誌",
    "systemLogsEmptyButMore": "目前載入的項目中沒有符合用戶端篩選條件的內容。可載入更多以向前搜尋。",
    "systemLogsEmptyDesc": "發生錯誤或警告時會顯示在這裡。",
    "systemLogsExplicitOnly": "僅限明確日誌",
    "systemLogsExplicitOnlyHint": "排除 console、未捕捉例外與框架捕捉項目",
    "systemLogsFailedLoad": "無法載入日誌",
    "systemLogsFilterActive": (count: number) => count === 0 ? '' : `已排除 ${count} 筆`,
    "systemLogsFilterClear": "重設篩選",
    "systemLogsFilterDevice": "裝置",
    "systemLogsFilterLevel": "層級",
    "systemLogsFilterOrigin": "來源端",
    "systemLogsFilterSource": "來源",
    "systemLogsFiltered": (shown: number, total: number) => `顯示 ${shown} / ${total} 筆`,
    "systemLogsFilters": "篩選條件",
    "systemLogsLevelAll": "所有層級",
    "systemLogsLevelError": "錯誤",
    "systemLogsLevelInfo": "資訊",
    "systemLogsLevelWarning": "警告",
    "systemLogsLoadMore": "載入更多",
    "systemLogsLoading": "載入中...",
    "systemLogsOriginAll": "全部",
    "systemLogsOriginClient": "用戶端",
    "systemLogsOriginServer": "伺服器",
    "systemLogsRefresh": "重新整理",
    "systemLogsSearchPlaceholder": "搜尋訊息、來源、平台或用戶端 ID",
    "togglePinUnbound": "已解除對話固定。",
    "togglePresetDeleted": (name: string) => `預設「${name}」已刪除。`,
    "togglePresetDuplicated": (name: string) => `已複製為「${name}」。`,
    "togglePresetExported": (name: string) => `預設「${name}」已匯出。`,
    "togglePresetRenamed": (oldName: string, newName: string) => `已將「${oldName}」重新命名為「${newName}」。`,
    "togglePresetSaved": (name: string) => `預設「${name}」已儲存。`,

    "httpInsecureWarningTitle": "透過 HTTP 連線",
    "httpInsecureWarningBody": "插件等部分功能可能無法使用。請使用遠端存取功能以建立 HTTPS 連線。",
    "httpInsecureOpenRemoteAccess": "開啟設定",

    "selectBotHint": "選擇一個機器人開始聊天",
} satisfies DeepPartial<typeof import('./en').languageEnglish>
